import React from 'react'
import { Paragraph, Text } from 'theme-ui'
import { CONTROLDText } from 'ui/CONTROLD'
import { FAQItem } from 'components/FrequentlyAskedQuestions'
import StyledLink from 'components/Organization/LandingPageCommonComponents/StyledLink'
import { DOCS_CONTROL_D_DOMAIN } from 'gatsby-env-variables'

export const frequentlyAskedQuestions: FAQItem[] = [
  {
    question: `What insights can Control D Analytics provide?`,
    answer: (
      <Paragraph>
        {CONTROLDText} Analytics provides insights into DNS queries, including top accessed domains,
        categories, blocked requests, and network usage trends. This helps you monitor activity and
        enhance security.
      </Paragraph>
    ),
  },
  {
    question: 'Can I generate customized reports?',
    answer: (
      <Paragraph>
        Yes, {CONTROLDText} allows you to create customized reports that match your business needs.
        You can tailor them to include specific data points or timeframes to help you understand
        network behavior.
      </Paragraph>
    ),
  },
  {
    question: 'How can real-time analytics benefit my business?',
    answer: (
      <Text>
        <Paragraph>
          Real-time analytics allow you to detect and respond to potential security threats
          immediately, minimizing risk. They also help you optimize network performance by
          identifying unusual patterns or bottlenecks. Typically, they offer the following three
          benefits.
        </Paragraph>
        <br />
        <Paragraph>
          <strong>Usage Patterns and Trends:</strong> Organizations gain an understanding of general
          internet usage, allowing them to identify abnormal patterns or potential security risks.
        </Paragraph>
        <br />
        <Paragraph>
          <strong>Activity Logs:</strong> Detailed logs show exactly what queries have been made,
          including additional metadata, which can be essential for audit trails and
          troubleshooting.
        </Paragraph>
        <br />
        <Paragraph>
          <strong>Data-Driven Decisions:</strong> By analyzing historical activity, companies can
          better strategize their internet policies and training programs.
        </Paragraph>
      </Text>
    ),
  },
  {
    question: `How long is historical data stored?`,
    answer: (
      <Paragraph>
        Historical data retention{' '}
        <StyledLink to={`${DOCS_CONTROL_D_DOMAIN}/docs/analytics`}>
          varies based on your preferences.
        </StyledLink>{' '}
        {CONTROLDText} provides options for different retention periods, allowing you to analyze
        past data to improve security and network performance.
      </Paragraph>
    ),
  },
  {
    question: `Can I try the Analytics feature before committing to a plan?`,
    answer: (
      <Paragraph>
        Yes, {CONTROLDText} offers a 30-day risk-free trial for all organizations. Sign up with your
        business email and start exploring the Analytics feature—no credit card required.
      </Paragraph>
    ),
  },
  {
    question: 'Can I get help setting up Analytics?',
    answer: (
      <Paragraph>
        Absolutely. You can <StyledLink to="/demo">book a demo</StyledLink> or consultation with our
        team, and we&apos;ll guide you through setting up and using Analytics to ensure your network
        is optimized and secure.
      </Paragraph>
    ),
  },
]
